exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ic-pagination {\r\n    display: block;\r\n}\r\n.ic-pagination {\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -ms-flex-direction: row;\r\n        flex-direction: row;\r\n    -ms-flex-pack: center;\r\n        justify-content: center;\r\n}\r\n.ic-pagination__item {\r\n    width: 24px;\r\n    height: 24px;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -ms-flex-pack: center;\r\n        justify-content: center;\r\n    -ms-flex-align: center;\r\n        align-items: center;\r\n    color: rgba(0, 0, 0, .88);\r\n}\r\n.ic-pagination__item {\r\n    cursor: pointer;\r\n}\r\n.ic-pagination__item--disable {\r\n    cursor: not-allowed;\r\n}\r\n.ic-pagination__item--disable {\r\n    color: rgba(0, 0, 0, .64);\r\n}\r\n.ic-pagination__item--active,\r\n.ic-pagination__item:not(.ic-pagination__item--disable):hover {\r\n    color: #0384ff;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// G:/3csoft/client-final/src/app/layout/pagination/pagination.component.css
// module id = ../../../../../src/app/layout/pagination/pagination.component.css
// module chunks = main